// extracted by mini-css-extract-plugin
export default {"shippingStatusContainer":"TE-z","shipmentMessage":"UE-z","shipmentNumber":"VE-z","trackingProgressContainer":"WE-z"};